const base_url = process.env.REACT_APP_API;

async function login(email, password) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const user = {
    auth: {
      email,
      password,
    },
  };

  try {
    const response = await fetch(`${base_url}/api/v1/auth/login`, {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: JSON.stringify(user),
    });
    const resp = await response.json();
    return resp;
  } catch (err) {
    console.error(err);
  }
}

async function getCurrenUser(userToken) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${userToken}`);
  try {
    const response = await fetch(
      `${base_url}/api/v1/current_student`,
      {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      }
    );
    const resp = await response.json();
    return resp;
  } catch (err) {
    console.error(err);
  }
}

async function logoutUser(userToken) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${userToken}`);
  try {
    const response = await fetch(
      `${base_url}/api/v1/auth/signout`,
      {
        method: "DELETE",
        headers: myHeaders,
      }
    );
    const resp = await response.json();
    return resp;
  } catch (err) {
    console.error(err);
  }
}

export { login, getCurrenUser, logoutUser };
